import { get_for_booking as _get_trips } from 'data/tour-vessel';
import { get_settings as get_agency_settings } from 'data/agency';
import { get as _get_tours } from 'data/tour';
import { check_availability } from 'data/tour-vessel';
import { get_all as get_booking_settings } from 'data/booking_setting';
import { get as get_cache, cache } from 'utils/cache';
import { unparams } from 'utils/urls';
import { 
    convertISOtoDate, 
    to_system_date, 
    tz_display_to_local, 
    local_to_tz_display,
    is_valid_timestamp,
    timestamp_to_date
} from 'utils/date';
import { strip_tags, esc_html } from 'utils/strings';
import {
    init as setup_modal,
    show as show_modal,
    hide as hide_modal,
    setup_opener as setup_modal_opener
} from 'ui/modal';
import { show_loading, hide_loading, observe_items } from 'ui/visibility';
import {
    MODAL_TEMPLATE,
    CATEGORY_TEMPLATE,
    CARD_TEMPLATE,
    PICKERS_TEMPLATE,
    TOUR_SPECIFIC_MODAL_TEMPLATE,
    TOUR_SPECIFIC_CARD_TEMPLATE
} from 'booking-widget/v1/common/templates';

import { init as init_guestpicker, get_guest_counts, set_guest_counts } from 'booking-widget/v1/widgets/guestpicker';
import { init as init_waitlist } from 'booking-widget/v1/widgets/waitlist';
import Cookies from 'js-cookie'

const BOOKING_STATUS_SOLD_OUT = 'sold-out';
const BOOKING_STATUS_AFTER_CUTOFF = 'cutoff';
const BOOKING_STATUS_AVAILABLE = 'available';

export const init = (options) => {
    // get the settings here so other widgets don't do duplicate calls.
    $.when(get_booking_settings()).then(function() {
        _init(options);
    })
}

const _init = (options) => {
    let io = null; // Intersection Observer
    let start = new Date();
    let end = new Date();
    end.setDate(end.getDate() + 7);
    let opts = $.extend({
        initial_day_range: 7,
        modal: false,
        tour_id: false,
        start_end: [start, end],
        adult: 2,
        child: 0,
        toddler: 0,
        time_of_day: '',
        on_view_url: function(){},
        on_book_url: function(){},
        on_book: function(){},
        on_gift: function(){},
        on_search: function(){},
        open_on_click: false,
        maintenance_message: false
    }, (options || {}));

    let el = options.context_el;
    if (!opts.modal) {
        el.empty();
    }

    let widget_el = el;
    let widget_id = (el.attr('id') ? el.attr('id') : 0)
    let modal_id = 'bw-modal-' + widget_id;
    let include_free_search = (typeof (el.attr('data-include-search')) !== 'undefined');
    let search_el = include_free_search ? $('> input[type="text"]:first-child', el) : $();
    let fetching = {};    // track if AJAX fetch of availability is already in progress
    let latest_cache_key = '';
    let is_tour_specific = (opts.tour_id && opts.tour_id > 0);
    
    let show_default_label = !is_tour_specific;
    let search_on_select = is_tour_specific;

    let url_opts = setup_from_url();
    if (url_opts.start_timestamp_between) {
        show_default_label = false;
        url_opts.start_end = [timestamp_to_date(url_opts.start_timestamp_between[0]), timestamp_to_date(url_opts.start_timestamp_between[1])];
    }
    opts = $.extend(opts, url_opts);

    if (opts.modal === true || is_tour_specific) {
        let template = is_tour_specific ? TOUR_SPECIFIC_MODAL_TEMPLATE : MODAL_TEMPLATE;
        setup_modal({
            html: template.replace(/\[modal_id\]/g, modal_id),
            // classes: 'ts-modal--height-80vh ts-modal--btvp',
            classes: 'bw-modal--tours ' + (is_tour_specific ? 'ts-modal--btvp' : ''),
            on_shown: function() {
                if (!opts.tour_id) {
                    let modal_el = $('#' + modal_id);
                    let position = search_el.offset();
                    let top = position.top + search_el.outerHeight() + 20; // 20px padding
                    let height = $(window).height() - top;
                    if (is_tour_specific) {
                        height -= top;
                    }
                    else {
                        height -= 20;
                    }
                    $('.bw-modal__container', modal_el).css({top: top + 'px', height: height + 'px'});
                }
            }
        });

        if (is_tour_specific) {
            widget_el = $('.btvp__booking-picker', '#' + modal_id);
        }
        else {
            widget_el = $('.bw-modal__content', '#' + modal_id);
        }
    }

    widget_el.append(PICKERS_TEMPLATE);

    let datepicker_el           = $('.bw-pickers__picker--datepicker', widget_el);
    let daterange_display_el    = $('.bw-pickers__datepicker-display', widget_el);
    let timepicker_el           = $('.bw-pickers__timepicker-control', widget_el);
    let guestpicker_control_el  = $('.bw-pickers__picker--guestpicker', widget_el);
    let results_el              = $('.bw__results', widget_el);
    let search_button_el        = $('.bw-pickers__btn-submit', widget_el);

    search_button_el.on('click', function(e) {
        e.preventDefault();
        get_trips();
    })

    timepicker_el.val(opts.time_of_day);
    timepicker_el.on('change', function() {
        if (search_on_select) {
            get_trips();
        }
    });

    init_guestpicker({
        id: 'bwgp-modal-' + widget_id,
        control: guestpicker_control_el,
        adult: opts.adult,
        child: opts.child,
        toddler: opts.toddler,
        is_tour_specific: is_tour_specific,
        refresh_control: function(guest_counts, control_el) {
            guestpicker_control_el.attr('data-touched', 1);
            set_guestpicker_display(guest_counts, control_el);
            if (search_on_select) {
                get_trips();
            }
        }
    });

    let guestpicker_el = $('#bwgp-modal-' + widget_id);
    let guest_counts = get_guest_counts(guestpicker_el);

    if (show_default_label) {
        set_datepicker_display(false, false);
        set_guestpicker_display(false, guestpicker_control_el);
    }
    else {
        if (url_opts.start_timestamp_between) {
            datepicker_el.attr('data-touched', 1);
            guestpicker_control_el.attr('data-touched', 1);
        }
        set_datepicker_display(opts.start_end[0], opts.start_end[1]);
        set_guestpicker_display(guest_counts, guestpicker_control_el);
    }

    init_daterangepicker();
    $(document).on('bw-daterangepicker-loaded', function() {
        init_daterangepicker();
    });
    if (include_free_search) {
        el.on('submit', function(e) {
            e.preventDefault();
            get_trips();
        })
    }
    else {
        if (!is_tour_specific || ('popup_onload' in url_opts)) {
            get_trips();
        }
    }

    if (opts.open_on_click && opts.open_on_click.length > 0) {
        opts.open_on_click.on('click', function(e) {
            e.preventDefault();
            get_trips();
        })
    }
    
    $(document).on('bw-maintenance-error', function(e, params) {
        let error = opts.maintenance_message ? opts.maintenance_message : params.error;
        if (!el.hasClass('bw--maintenance-mode')) {
            el.addClass('bw--maintenance-mode').empty();
            setup_modal({
                html: MODAL_TEMPLATE.replace(/\[modal_id\]/g, 'maintenance-modal'),
                on_shown: function(e, params) {
                    $('.bw-modal__content', '#maintenance-modal').text(error);
                }
            });
            let modal_el = $('#maintenance-modal');
            load_logo(modal_el);
            show_modal(modal_el);

        }
    });

    // daterangepicker does not have timezones, but we need to display calendar in HST 
    // (like "today" in Japan is not the same day in Hawaii)
    // Whenever dates go into daterangepicker it needs to be converted from local to HST.
    // Whenever dates come out of daterangepicker it needs to be converted from HST to local.
    function init_daterangepicker() {
        if (!$.fn.daterangepicker) {
            return;
        }
        if (datepicker_el.hasClass('drp-initialized')) {
            return;
        }
        datepicker_el
            .daterangepicker({
                opens: is_tour_specific ? 'left' : 'right',
                minDate: local_to_tz_display(new Date(), opts.utc_offset),
                startDate: local_to_tz_display(opts.start_end[0], opts.utc_offset),
                endDate: local_to_tz_display(opts.start_end[1], opts.utc_offset),
                maxSpan: { weeks: 6 },
                alwaysShowCalendars: false,
                autoApply: true
            })
            .on('click.daterangepicker', function(e) {
                let dp = datepicker_el.data('daterangepicker');
                if (!dp.justOpened) {
                    dp.hide();
                }
                dp.justOpened = false;
            })
            .on('apply.daterangepicker', function(ev, picker) {
                let start_date = tz_display_to_local(picker.startDate.toDate(), opts.utc_offset);
                let end_date = tz_display_to_local(picker.endDate.toDate(), opts.utc_offset);

                let original = timepicker_el.val();
                let tod = get_tod(picker);
                datepicker_el.attr('data-touched', 1);

                set_datepicker_display(start_date, end_date);
                    
                if (search_on_select) {
                    get_trips();
                }
            })
            .on('show.daterangepicker', function(ev, picker) {
                picker.justOpened = true;
                $(".bw-pickers__picker-toggle", datepicker_el)
                    .removeClass('bw__icomoon--expand_more')
                    .addClass('bw__icomoon--expand_less')
                ;
                // scroll up so calendars can show 
                if ($(window).height() <= 700) {
                    
                    daterange_display_el.closest('.bw-modal__content').animate({
                        scrollTop: daterange_display_el.get(0).offsetTop // always the same even after scroll
                    }, {
                        duration: 0,
                        complete: function() {
                            picker.move();
                        }
                    });
                }
                if ($(window).width() <= 600) {
                    let picker_el = $(picker.container);
                    let left = picker_el.position().left;
                    picker_el.css({width: 'calc(100% - ' + (left*2) + 'px)'});
                }
            })
            .on('hide.daterangepicker', function(ev, picker) {
                picker.justOpened = false;
                $(".bw-pickers__picker-toggle", datepicker_el)
                    .removeClass('bw__icomoon--expand_less')
                    .addClass('bw__icomoon--expand_more')
                ;
            })
            .addClass('drp-initialized')
        ;

        window.addEventListener('popstate', function(e) {
            if (location.href.indexOf('#!') == -1) {
                return;
            }

            let url_opts = setup_from_url();
            if (url_opts.start_timestamp_between) {
                url_opts.start_end = [timestamp_to_date(url_opts.start_timestamp_between[0]), timestamp_to_date(url_opts.start_timestamp_between[1])];
            }
            opts = $.extend(opts, url_opts);
            let start_date = opts.start_end[0];
            let end_date = opts.start_end[1];
            datepicker_el.data('daterangepicker').setStartDate(local_to_tz_display(start_date, opts.utc_offset));
            datepicker_el.data('daterangepicker').setEndDate(local_to_tz_display(end_date, opts.utc_offset));
            set_datepicker_display(start_date, end_date);

            set_guest_counts(guestpicker_el, opts);
            set_guestpicker_display(opts, guestpicker_control_el);
            
            get_trips();
        });

    }

    // get time of day from picker
    function get_tod(picker) {
        let tod = '';
        let already_set = false;
        $('input[name="dp_timepicker"]:checked', picker.container).each(function() {
            if (already_set) {
                tod = ''; // both checked means anytime
            }
            else {
                tod = this.value;
                already_set = true;
            }
        });
        return tod;
    }
    
    function set_guestpicker_display(guest_counts, control_el) {
        let str = 'Add guests';
        if (guest_counts !== false) {
            str = '<span>' + guest_counts.adult + ' Adult' + '</span>';
            if (guest_counts.child > 0) {
                str += ' <span>' + guest_counts.child + ' Child' + '</span>';
            }
            if (guest_counts.toddler > 0) {
                str += ' <span>' + guest_counts.toddler + ' Toddler' + '</span>';
            }
        }

        $('.bw-pickers__guestpicker-display', control_el).html(str);
    }

    function set_datepicker_display(start_date, end_date, tod) {
        let str = 'Choose your dates';
        if (start_date !== false) {
            str = local_to_tz_display(start_date, opts.utc_offset).toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
            str += ' - ' + local_to_tz_display(end_date, opts.utc_offset).toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
            if (typeof tod !== 'undefined' && tod !== false) {
                str += '<div>' + ((tod !='') ? tod : 'Anytime') + '</div>';
            }
        }
        daterange_display_el.html(str);
    }

    function get_search_params() {
        let dp = datepicker_el.data('daterangepicker');

        let start_local = dp ? tz_display_to_local(dp.startDate.toDate(), opts.utc_offset) : opts.start_end[0];
        let end_local = dp ? tz_display_to_local(dp.endDate.toDate(), opts.utc_offset) : opts.start_end[1];

        // let start_local = tz_display_to_local(dp_start, opts.utc_offset);
        let start_timestamp = start_local.getTime();
        let end_timestamp = end_local.getTime();

        let now = new Date();
        // if today, set the time
        if (to_system_date(now) === to_system_date(start_local)) {
            start_local.setHours(now.getHours(), now.getMinutes());
            start_timestamp = start_local.getTime()
        }

        let time_of_day = timepicker_el.val();
        let guest_counts = get_guest_counts(guestpicker_el);

        let pax_count = guest_counts.adult + guest_counts.child + guest_counts.toddler;
        let search_params = {
            start_timestamp_between: [start_timestamp, end_timestamp],
            time_of_day: time_of_day,
            adult: guest_counts.adult,
            child: guest_counts.child,
            toddler: guest_counts.toddler,
            has_toddlers: (guest_counts.toddler > 0),
            capacity_max: pax_count
        };

        if (opts.tour_id) {
            search_params.tour_id = opts.tour_id;
            search_params.pax_count = pax_count;
        }

        return search_params;
    }

    function is_default_search() {
        return !is_tour_specific && (guestpicker_control_el.attr('data-touched') == 0 && datepicker_el.attr('data-touched') == 0);
    }

    function get_trips() {
        let search_params = get_search_params();
        let default_search = is_default_search();
        if (default_search) {
            let next_year = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
            search_params = {
                start_timestamp_between: [Date.now(), next_year.getTime()],
                group: 'tour_vessel.tour_id'
            }
        }
        let cache_key = 'booking-tours-' + JSON.stringify(search_params);
        latest_cache_key = cache_key;
        if ((cache_key in fetching) && fetching[cache_key]) {
            // already fetching this query.
            return;
        }

        opts.on_search();

        fetching[cache_key] = true;
        let cached = get_cache(cache_key);
        if (cached != false) {
            delete fetching[cache_key];
            render_results(cached.data);
            if (opts.modal) {
                let modal_el = $('#' + modal_id);
                load_logo(modal_el);
                show_modal(modal_el);
            }
            return;
        }
        show_loading(widget_el);
        $.when(_get_trips(search_params), get_tours(), get_agency_settings())
            .then(function(trips_json, tours_now_cached, settings_cached) {

                if (!default_search && history.pushState) {
                    search_params.popup_onload = true;
                    if (!is_search_params_equal(setup_from_url(), search_params)) {
                        history.pushState(null, null, '#!' + $.param(search_params));
                    }
                }
                
                delete fetching[cache_key];
                cache(cache_key, trips_json);
                render_results(trips_json.data);
                if (opts.modal) {
                    let modal_el = $('#' + modal_id);
                    load_logo(modal_el);
                    show_modal(modal_el);
                }
                hide_loading(widget_el);
            })
        ;
    }

    function render_results(data) {

        setup_waitlist();

        if (opts.tour_id) {
            render_tour_results(data, opts.tour_id);
        }
        else {
            render_all_results(data);
        }
    }

    function render_tour_results(data, tour_id) {
        let tour_data = get_cache('tours').data;

        results_el.empty();
        
        if (typeof tour_data === 'undefined') {
            return;
        }
        
        // get tour 
        let tour = tour_data.filter(function(t) {
            return t.id == tour_id;
        })[0];

        let booking_settings = get_cache('booking-settings');
        booking_settings = booking_settings.data;

        let tour_desc_el = $('.btvp__tour-description', modal_content_el);
        let tour_name_el = $('.btvp__header', modal_content_el);
        let checkin_min_el = $('.btvp__checkin', modal_content_el);

        if (tour_desc_el.is(':empty')) {
            tour_desc_el.append(strip_tags(tour.description, '<button><div><p><a><strong>'));
            $('[data-show]', tour_desc_el).off('click').on('click', function() {
                let att = $(this).attr('data-show');
                show_div(att, modal_content_el);
            });
            $('[data-hide]', tour_desc_el).off('click').on('click', function() {
                let att = $(this).attr('data-hide');
                hide_div(att, modal_content_el);
            });
        }
        if (tour_name_el.is(':empty')) {
            tour_name_el.text(tour.name);
        }
        if (checkin_min_el.is(':empty')) {
            checkin_min_el.text(tour.checkin_minutes);
        }

        if (data.length == 0) {
            results_el.append('<p class="bw-gray" style="text-align:center">- No results found -</p>');
            return;
        }

        // update guest picker
        refresh_guestpicker_control(guestpicker_control_el, data);

        let modal_content_el = widget_el.closest('.bw-modal__content');
        let unique_tours = {}; // only get one per time slot
        for (let i = 0; i < data.length; i++) {
            let tv = data[i];
            if (!(tv.start_time in unique_tours)) {
                unique_tours[tv.start_time] = tv;
            }
            else if (Number(tv.vessel[0].booking_priority) < Number(unique_tours[tv.start_time].vessel[0].booking_priority)) {
                unique_tours[tv.start_time] = tv;
            }
        }

        for (let t in unique_tours) {
            let tv = unique_tours[t];
            let start_date = convertISOtoDate(tv.start_time);
            let end_date = convertISOtoDate(tv.end_time);
            let end_date_str = end_date.toLocaleTimeString('en-US', {hour:'numeric', minute:'2-digit'})
            if (tour.end_date_display && tour.end_date_display != '') {
                end_date_str = tour.end_date_display;
            }
            
            // Past cutoff time - Shows contact us
            let booking_status = get_booking_status(tv);
            results_el.append(TOUR_SPECIFIC_CARD_TEMPLATE
                .replace(/\[start_time\]/g, start_date.toLocaleTimeString('en-US', {hour:'numeric', minute:'2-digit'}))
                .replace(/\[end_time\]/g, esc_html(end_date_str))
                .replace(/\[day_month_date\]/g, start_date.toLocaleDateString('en-US', {day:'numeric', weekday:'short', month:'short'}))
                .replace(/\[adult_price\]/g, Number(tv.adult_price_base))
                .replace(/\[child_price\]/g, Number(tv.child_price_base))
                .replace(/\[tour_vessel_id\]/g, esc_html(tv.id))
                .replace(/\[payment_url\]/g, esc_html(opts.payment_url))
                .replace(/\[booking_status_class\]/g, 'bw-tours__row--' + esc_html(booking_status))
                .replace(/\[tour_id\]/g, esc_html(tour.id))
                .replace(/\[capacity\]/g, esc_html(tv.vessel[0].capacity_max))
            );
        }

        $('.bw-tours__button--book', results_el).off('click').on('click', function(e) {
            e.preventDefault();
            // save cookie
            let btn = $(this);
            let trip_id = btn.attr('data-tour-vessel-id');
            let search_params = get_search_params();
            Cookies.set('ca-cart', JSON.stringify({
                trip_id: trip_id,
                tour_id: tour.id,
                pax_counts: {
                    adult: search_params.adult,
                    child: search_params.child,
                    toddler: search_params.toddler,
                }
            }), { sameSite: 'strict' });

            let results = data.filter(function(tv) {
                return (tv.id == trip_id);
            })
            let passenger_count = search_params.adult + search_params.child + search_params.toddler;
            // let passenger_param = Array.apply(null, Array(passenger_count)).map(function () {});
            let passenger_param = Array(passenger_count).fill(null);
            check_availability({
                id: trip_id,
                data: {
                    passenger_id: passenger_param,
                    contact_status: passenger_param
                },
                on_done: function(json) {
                    if (json.success && json.has_availability) {
                        opts.on_book((results.count > 0 ? results[0] : false), search_params);
                    }
                    else if (!json.has_availability) {
                        btn
                            .closest('.bw-tours__row')
                            .removeClass('bw-tours__row--available')
                            .removeClass('bw-tours__row--cutoff')
                            .addClass('bw-tours__row--sold-out')
                        ;
                        btn
                            .text("SOLD OUT!")
                            .addClass('bw-tours__button--sold-out');
                    }
                }
            })
        });

        $('#' + modal_id + ' .bw-gift-tour').off('click').on('click', function(e) {
            e.preventDefault();
            let search_params = get_search_params();
            opts.on_gift(tour, search_params, );
        });

        let waitlist_link_el = $('.bw-tours__waitlist-link', results_el);
        waitlist_link_el.off('click');
        setup_modal_opener(waitlist_link_el);   

    }

    function render_all_results(data) {
        let lowest_prices = {};
        let unique_tours = {};
        let tours = {};
        let tour_data = get_cache('tours').data;
        let lazy_selector = '.bw-tours__card__img';

        if (io) {
            document.querySelectorAll(lazy_selector).forEach(function(element) { 
                io.unobserve(element);
            });
            io = null;
        }

        results_el.empty();
        if (typeof tour_data === 'undefined' || data.length == 0) {
            results_el.append('<h2 class="bw__results--no-tours">No tours found</h2>');
            return;
        }

        for (let i = 0; i < tour_data.length; i++) {
            tours[tour_data[i].id] = tour_data[i];
        }

        for (let i = 0; i < data.length; i++) {
            let tv_data = data[i];
            let tour_id = tv_data.tour_id;

            if (!(tour_id in tours)) {
                continue;
            }

            let tour_category_id = tours[tour_id].category_id;
            let adult_price = Number(tv_data.adult_price_base);
            let child_price = Number(tv_data.child_price_base);

            // each tour needs a category so we know where to place it.
            if (tour_category_id == 0) {
                continue;
            }

            // get lowest price
            if (tour_id in lowest_prices) {
                if (adult_price < Number(lowest_prices[tour_id].adult)) {
                    lowest_prices[tour_id].adult = adult_price
                }
                if (child_price < Number(lowest_prices[tour_id].child)) {
                    lowest_prices[tour_id].child = child_price
                }
            }
            else {
                lowest_prices[tour_id] = {
                    adult: adult_price,
                    child: child_price
                };
            }

            // find unique tours
            let seats_available = Number(tv_data.seats_available);
            if (!(tour_id in unique_tours)) {
                let tv_cat = tours[tour_id].tour_category[0];
                let cat_display_order = parseInt(tv_cat.display_order) || 0;
                let display_order = parseInt(tv_data.display_order) || 0;
                tv_data.display_order = cat_display_order*100 + display_order;
                tv_data.max_seats_available = seats_available;
                unique_tours[tour_id] = tv_data;
            }
            else {
                unique_tours[tour_id].max_seats_available = Math.max(seats_available, unique_tours[tour_id].max_seats_available);
                // get latest cutoff time
                unique_tours[tour_id].cutoff_timestamp = Math.max(tv_data.cutoff_timestamp, unique_tours[tour_id].cutoff_timestamp);
                
            }
        }
        
        refresh_guestpicker_control(guestpicker_control_el, data);
        
        // now sort
        let sorted_trips = Object.values(unique_tours).sort(function(a, b) {
            return (a.display_order > b.display_order) ? 1 : -1;
        });

        let guest_counts = get_guest_counts(guestpicker_el);
        let total_count = guest_counts.adult + guest_counts.child + guest_counts.toddler;
        let default_search = is_default_search();
        for (let i = 0; i < sorted_trips.length; i++) {
            let tv = sorted_trips[i];
            let tour = tours[tv.tour_id];
            let time_diff = (convertISOtoDate(tv.end_time) - convertISOtoDate(tv.start_time)) / (1000 * 60 * 60);
            let tour_category = tour.tour_category[0];
            if (tour.category_id === null) {
                continue;
            }

            let category_el = setup_category_el(results_el, tour_category);

            // Sold out, Not enough seats - Shows Sold out, add to waitlist.
            // Past cutoff time - Shows contact us
            // Always show available if a search wasn't triggered by the user bc just we have trip one per tour.
            let booking_status = !default_search ? get_booking_status(tv, total_count) : BOOKING_STATUS_AVAILABLE;

            $('.bw-tours__list', category_el).append(CARD_TEMPLATE
                .replace(/\[tour_image_url\]/g, encodeURI(tour.search_image_url))
                .replace(/\[tour_name\]/g, esc_html(tour.name))
                .replace(/\[tour_duration\]/g, Math.round(time_diff * 10) / 10)
                .replace(/\[adult_price\]/g, esc_html(lowest_prices[tour.id].adult))
                .replace(/\[child_price\]/g, esc_html(lowest_prices[tour.id].child))
                .replace(/\[tour_id\]/g, esc_html(tour.id))
                .replace(/\[trip_id\]/g, esc_html(tv.id))
                .replace(/\[seats_available\]/g, esc_html(tv.seats_available) + ' SEAT' + (tv.seats_available > 1 ? 'S' : ''))
                .replace(/\[capacity\]/g, esc_html(tv.vessel[0].capacity_max))
                .replace(/\[booking_status_class\]/g, 'bw-tours__card--' + esc_html(booking_status))
            );
        }

        $('.bw-tours__button--book', results_el).off('click').on('click', function(e) {
            e.preventDefault();
            let search_params = get_search_params();
            search_params.tour_id = $(this).closest('.bw-tours__card').attr('data-tour-id');
            // these don't need to be in the url
            search_params = cleanup_for_url(search_params);
            let tour = (search_params.tour_id in tours) ? tours[search_params.tour_id] : false;
            search_params.book = '';
            let url = opts.on_book_url(tour, search_params);
            window.open(url + '#!' + $.param(search_params), '_blank');
        });

        $('.bw-tours__card__bottom, .bw-tours__card__img, .bw-tours__detail-link', results_el).off('click').on('click', function(e) {
            if($(this).hasClass('bw-tours__card__img') || (!$(e.target).hasClass('bw-tours__button') && !$(e.target).hasClass('bw-tours__waitlist-link'))) {
                e.preventDefault();
                let tour_id = $(this).closest('.bw-tours__card').attr('data-tour-id');
                let search_params = get_search_params();
                search_params.tour_id = $(this).closest('.bw-tours__card').attr('data-tour-id');
                search_params = cleanup_for_url(search_params);
                let url = opts.on_view_url(tours[tour_id]);
                if (is_default_search()) {
                    window.open(url, '_blank');
                }
                else {
                    window.open(url + '#!' + $.param(search_params), '_blank');
                }
            }
        });

        let waitlist_link_el = $('.bw-tours__waitlist-link', results_el);
        waitlist_link_el.off('click');
        setup_modal_opener(waitlist_link_el);      
        
        io = observe_items({
            on_intersect: function(target_dom) {
                // for some reason this sets the shorthand background property so need to re set everything
                target_dom.style.backgroundImage = 'url(' + target_dom.dataset.image + ')';
                target_dom.style.backgroundRepeat = 'no-repeat';
                target_dom.style.backgroundSize = 'cover';
                target_dom.style.backgroundPosition = 'center center';
            },
            selector: lazy_selector
        });
    }

    function setup_category_el(results_el, category_data) {
        let category_el = $('.bw-tour-category-' + category_data.id, results_el);
        
        if (category_el.length != 0) {
            return category_el;
        }

        results_el.append(CATEGORY_TEMPLATE
                .replace(/\[tour_category_id\]/g, esc_html(category_data.id))
                .replace(/\[tour_category_name\]/g, esc_html(category_data.name))
                .replace(/\[tour_category_url\]/g, encodeURI(category_data.url))
                .replace(/\[tour_category_icon\]/g, encodeURI(category_data.icon_url))
        );

        return $('.bw-tour-category-' + category_data.id, results_el);
    }


    function get_tours() {
        let d = $.Deferred();

        let cached = get_cache('tours');
        if (cached != false) {
            d.resolve(cached);
            return null;
        }
        _get_tours({
            fields: 'id,name,tour_url,tour_info_url,category_id,display_order,description,search_image_url,checkin_minutes,end_date_display,tour_category.id,tour_category.name,tour_category.url,tour_category.icon_url,tour_category.display_order',
            expand: 'tour_category',
            on_done: function(json) {
                cache('tours', json);
                d.resolve(json);
            }
        });

        return d.promise();
    }

    function is_raft_category(category_obj) {
        return category_obj.name.toLowerCase().indexOf('raft') !== -1;
    }

    function get_booking_status(trip, seats_needed) {
        if (trip.max_seats_available <= 0) {
            return BOOKING_STATUS_SOLD_OUT;
        }
        else if (typeof seats_needed !== 'undefined' && trip.max_seats_available < seats_needed) {
            return BOOKING_STATUS_SOLD_OUT;
        }
        else if (Date.now() > (parseInt(trip.cutoff_timestamp * 1000) || Date.now())) {
            if (!is_allowing_late()) {
                return BOOKING_STATUS_AFTER_CUTOFF;
            }
        }

        return BOOKING_STATUS_AVAILABLE;
    }

    // set the pickers based on the url params, pickers need to be added to dom first.
    function setup_from_url() {
        let params = unparams(window.location.hash.replace(/^#!/, ''));
        let valid_search_params = {};
        if (params.start_timestamp_between && Array.isArray(params.start_timestamp_between) && params.start_timestamp_between.length == 2) {
            if (is_valid_timestamp(params.start_timestamp_between[0]) && is_valid_timestamp(params.start_timestamp_between[1])) {
                valid_search_params.start_timestamp_between = params.start_timestamp_between;
            }
        }
        
        if (params.adult && (parseInt(params.adult) || false) !== false ) {
            valid_search_params.adult = parseInt(params.adult);
        }
        if (params.child && (parseInt(params.child) || false) !== false ) {
            valid_search_params.child = parseInt(params.child);
        }
        if (params.toddler && (parseInt(params.toddler) || false) !== false ) {
            valid_search_params.toddler = parseInt(params.toddler);
        }
        if (params.time_of_day && (['', 'morning', 'afternoon'].indexOf(params.time_of_day) !== -1)) {
            valid_search_params.time_of_day = params.time_of_day;
        }
        else {
            valid_search_params.time_of_day = '';
        }
        let query_params = unparams(window.location.search.replace('?', ''));
        if ('book' in params || 'book' in query_params) {
            valid_search_params.popup_onload = true;
            if (params.book == 1 || query_params.book == 1) {
                Cookies.set('ca-allow-late', 1, { sameSite: 'strict' });
                valid_search_params.allow_late = true;
            }
        }
        if ('popup_onload' in params) {
            valid_search_params.popup_onload = params.popup_onload;
        }

        return valid_search_params;
    }

    // the search filters are the only thing that matters, check if any of the search control values changed.
    function is_search_params_equal(param1, param2) {
        let same = true;
        same &= (('start_timestamp_between' in param1) == ('start_timestamp_between' in param2));
        same &= (!('start_timestamp_between' in param1) || param1.start_timestamp_between[0] == param2.start_timestamp_between[0]);
        same &= (!('start_timestamp_between' in param1) || param1.start_timestamp_between[1] == param2.start_timestamp_between[1]);
        same &= ((param1.adult ? param1.adult : 1) == (param2.adult ? param2.adult : 1));
        same &= ((param1.child ? param1.child : 0) == (param2.child ? param2.child : 0));
        same &= ((param1.toddler ? param1.toddler : 0) == (param2.toddler ? param2.toddler : 0));
        same &= ((param1.time_of_day ? param1.time_of_day : '') == (param2.time_of_day ? param2.time_of_day : ''));

        return same;
    }


    // cleanup vars that don't need to be in url.
    function cleanup_for_url(search_params) {
        let url_params = $.extend({}, search_params);
        delete url_params.has_toddlers;
        delete url_params.pax_count;
        delete url_params.popup_onload;
        delete url_params.book;
        delete url_params.allow_late;

        return url_params;
    }

    function setup_waitlist() {
        init_waitlist({
            on_shown: function(modal_el) {
                // set the same dates in the waitlist calendar
                let dp_start = datepicker_el.data('daterangepicker').startDate.toDate();
                let dp_end = datepicker_el.data('daterangepicker').endDate.toDate();
                $('.bw-waitlist__datepicker', modal_el).data('daterangepicker').setStartDate(dp_start);
                $('.bw-waitlist__datepicker', modal_el).data('daterangepicker').setEndDate(dp_end);

                // set the same passenger counts
                let guest_counts = get_guest_counts(guestpicker_el);
                $('#bw-waitlist-adult', modal_el).val(guest_counts.adult);
                $('#bw-waitlist-child', modal_el).val(guest_counts.child);
                $('#bw-waitlist-toddler', modal_el).val(guest_counts.toddler);
            },
            utc_offset: opts.utc_offset,
            trips: function() {
                return get_cache(latest_cache_key);
            }
        });
    }

    /**
     * Functions to show/hide div in tour descriptions
     */
    function show_div(show_id, context_el){
        // content
        $('#' + show_id, context_el).removeClass('hide');
        // links to show/hide
        $('#b' + show_id, context_el).addClass('hide');
        $('#h' + show_id, context_el).removeClass('hide');
    }

    function hide_div(show_id, context_el){
        // content
        $('#' + show_id, context_el).addClass('hide');
        // links to show/hide
        $('#b' + show_id, context_el).removeClass('hide');
        $('#h' + show_id, context_el).addClass('hide');
    }

    /**
     * Return true if the cookie to allow late or url param is set.
     */
    function is_allowing_late() {
        let allow_late = Cookies.get('ca-allow-late');
        return (typeof allow_late !== 'undefined' && allow_late == 1);
    }

    /**
     * Refresh attributes of the guest picker based on results.
     */
    function refresh_guestpicker_control(guestpicker_control_el, data) {
        if (data.length > 0) {
            guestpicker_control_el.attr('data-vessel-type', data[0].vessel[0].vessel_type);   
            guestpicker_control_el.attr('data-capacity', data[0].vessel[0].capacity_max);
        }

        let vessel_exclusions = {};
        let hide_toddlers = true;
        for (let i = 0; i < data.length; i++) {
            let tv = data[i];
            let v = tv.vessel[0];
            if (v.vessel_type in vessel_exclusions) {
                continue;
            }
            vessel_exclusions[v.vessel_type] = v.toddlers_allowed + '-' + v.pregnant_allowed;

            if (v.toddlers_allowed == 1) {
                hide_toddlers = false;
            }

            if (Object.keys(vessel_exclusions).length == 2) {
                break;
            }
        }
        guestpicker_control_el.attr('data-exclusions', JSON.stringify(vessel_exclusions));
        guestpicker_control_el.attr('data-hide-toddlers', hide_toddlers ? 1 : 0);
    }

    /**
     * Load the logo image
     */
    function load_logo(modal_el) {
        let powered_by_el = $('.bw__powered-by img', modal_el);
        if (!powered_by_el.hasClass('loaded')) {
            powered_by_el[0].src = powered_by_el.attr('data-src');
            powered_by_el.addClass('loaded');
        }
    }

}
